import React, { Component } from 'react'
import { reduxForm, Field, formValueSelector } from 'redux-form'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import axios from 'axios'

import Row from '../../../common/layout/row'
import LabelAndInput from '../../../common/form/LabelAndInput'
import { init, create, update, getList, refreshList, showContent, showCreate } from '../duck/crashSignal.duck'
import If from '../../../common/operator/If';
import Table from '../../../common/layout/Table';
import Content from '../../../common/template/Content';
import { formatLocalDateTime, formatUtcAsLocal, parseAsLocal, toApiLocal, toLocalInputValue } from '../utils/datetime'
import {
    PREVIEW_BASE,
    PREVIEW_STEPS,
    formatSignedReais,
    galeTypeLabel,
    galeTypeShort,
    typeResultsForSignal,
} from '../utils/galePreview'

class FormCrashSignal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showForm: false,
            isEdit: false,
            percent_to_start: 0.2,
            martingale_steps: 2
        }

        this.onSubmit = this.onSubmit.bind(this)
        this.pollPendingSignals = this.pollPendingSignals.bind(this)
    }

    pollTimer = null

    componentWillMount() {
        if (this.props.userId !== null) {
            this.props.getList()
            this.getGeneralStatuses()
        }
    }

    componentDidMount() {
        this.pollTimer = setInterval(this.pollPendingSignals, 5000)
    }

    componentDidUpdate(prevProps) {
        if (this.props.userId != null && prevProps.userId == null) {
            this.props.getList()
            this.getGeneralStatuses()
        }
    }

    componentWillUnmount() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer)
            this.pollTimer = null
        }
    }

    /** Sinal ainda sem Sucesso/Falha e cujo minuto já começou. */
    isAwaitingResult = (signal) => {
        if (!signal) return false
        const outcome = signal.outcome
        if (outcome && outcome !== 'Pendente') return false
        const d = parseAsLocal(signal.date)
        if (!d) return false
        const minuteStart = new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), 0, 0)
        return Date.now() >= minuteStart.getTime()
    }

    pollPendingSignals = () => {
        const list = this.props.list || []
        if (!list.length) return
        if (list.some(this.isAwaitingResult)) {
            this.props.refreshList()
        }
    }

    onSubmit(crashSignal) {
        crashSignal.user_id = this.props.userId
        crashSignal.date = toApiLocal(crashSignal.date)
        if (crashSignal.id) {
            this.props.update(crashSignal)
        } else {
            this.props.create(crashSignal)
        }
    }

    getGeneralStatuses = () => {
        axios.get(`${process.env.REACT_APP_API_HOST}/general_statuses`, { silent: true })
        .then(resp => {
            this.setState({ generalStatuses: resp.data.data })
        })
        .catch(e => {
            console.warn('getGeneralStatuses falhou', e && e.message)
        })
    }

    /** Crash mínimo (>=) que define sucesso do sinal; herdado do prompt. */
    minResultOf = (signal) => {
        const n = Number(signal && signal.min_result)
        return Number.isFinite(n) && n > 1 ? n : 2
    }

    /**
     * Jogada real do bot neste sinal: tipo, sequência inteira e P&L.
     * Soros gale em Falha não encerra — o prejuízo segue até um win.
     */
    renderBotActivity = (activity, signal) => {
        if (!activity || !activity.bets) return '—'

        const types = Array.isArray(activity.gale_types) && activity.gale_types.length
            ? activity.gale_types
            : (activity.gale_type ? [activity.gale_type] : [])
        const typeLabel = types.length === 1
            ? galeTypeShort(types[0])
            : (types.length > 1 ? 'Vários' : '')
        const sequence = Array.isArray(activity.stakes) && activity.stakes.length
            ? activity.stakes.map((n) => Math.round(Number(n) || 0)).join('+')
            : `${activity.bets}×`
        const pnl = activity.pnl != null && Number.isFinite(Number(activity.pnl))
            ? Math.round(Number(activity.pnl))
            : null
        const recovering = types.length === 1
            && types[0] === 'soros_gale'
            && !activity.won
            && signal
            && signal.outcome === 'Falha'
        const color = recovering ? '#ef6c00' : (activity.won ? '#2e7d32' : '#c62828')
        const result = recovering
            ? 'recupera'
            : (pnl != null ? formatSignedReais(pnl) : (activity.won ? 'win' : 'loss'))
        const label = [typeLabel, sequence, result].filter(Boolean).join(' ')
        const detail = [
            types.length ? types.map(galeTypeLabel).join(', ') : null,
            `${activity.bets} entrada(s)`,
            sequence !== `${activity.bets}×` ? `R$ ${sequence}` : null,
            `auto-retirar ${Number(activity.factor).toFixed(2)}x`,
            `saldo R$ ${Math.round(Number(activity.credit) || 0)}`,
            `${activity.bots} bot(s)`,
            recovering ? 'prejuízo segue no próximo sinal' : null,
        ].filter(Boolean).join(' · ')

        return (
            <b title={detail} style={{ color }}>{label}</b>
        )
    }

    outcomeColor = (outcome) => {
        if (outcome === 'Pendente') return '#f9a825'
        if (outcome === 'Pulou') return '#757575'
        if (outcome === 'Sucesso') return '#2e7d32'
        return '#c62828'
    }

    renderOutcome = (signal) => {
        const outcome = (signal && signal.outcome) || 'Falha'
        const pos = Number(signal && signal.actual_position)
        const posLabel = outcome === 'Sucesso' && Number.isFinite(pos) && pos > 0 ? ` · ${pos}ª` : ''
        const types = typeResultsForSignal(signal, this.minResultOf(signal))
        return (
            <div title={`Hit do crash (todas as escadas jogam até ${PREVIEW_STEPS} mãos). P&L simulado com entrada R$ ${PREVIEW_BASE}; auto-retirar só no crédito.`}>
                <b style={{ color: this.outcomeColor(outcome) }}>{outcome}{posLabel}</b>
                {types.length > 0 && (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '2px 8px', fontSize: 11, marginTop: 3, fontWeight: 600 }}>
                        {types.map((row) => (
                            <span
                                key={row.type}
                                title={`${row.label} ${Array.isArray(row.stakes) ? row.stakes.join('+') : ''} ${formatSignedReais(row.pnl)}${row.carries ? ' · prejuízo segue' : ''}`}
                                style={{ color: row.carries ? '#ef6c00' : (row.won ? '#2e7d32' : '#c62828') }}
                            >
                                {row.short} {formatSignedReais(row.pnl)}{row.carries ? '*' : ''}
                            </span>
                        ))}
                    </div>
                )}
            </div>
        )
    }

    renderTypeResultsTable(signal) {
        const rows = typeResultsForSignal(signal, this.minResultOf(signal))
        if (!rows.length) return null
        const minResult = this.minResultOf(signal)
        return (
            <div style={{ marginBottom: 12 }}>
                <strong>
                    Por tipo de aposta (entrada R$ {PREVIEW_BASE}, até {PREVIEW_STEPS} jogadas; auto-retirar {minResult}x só no P&amp;L)
                </strong>
                <table className='table table-condensed table-bordered' style={{ marginTop: 8, marginBottom: 0, background: '#fff' }}>
                    <thead>
                        <tr>
                            <th>Tipo</th>
                            <th>Escada</th>
                            <th>Posição</th>
                            <th>R$</th>
                            <th>Nota</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row) => {
                            const note = row.carries
                                ? 'prejuízo segue'
                                : (row.won
                                    ? (row.type === 'soros' ? 'reinveste no próximo' : '')
                                    : 'perda do sinal')
                            return (
                                <tr key={row.type} style={{ background: row.carries ? '#fff3e0' : (row.won ? '#e8f5e9' : '#ffebee') }}>
                                    <td>{row.label}</td>
                                    <td>{Array.isArray(row.stakes) ? row.stakes.join(' + ') : '—'}</td>
                                    <td>{row.position ? `${row.position}ª` : '—'}</td>
                                    <td style={{ fontWeight: 600, color: row.carries ? '#ef6c00' : (row.won ? '#2e7d32' : '#c62828') }}>
                                        {formatSignedReais(row.pnl)}
                                    </td>
                                    <td>{note}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        )
    }

    renderAroundResults = (signal) => {
        const rows = signal.around_results || []
        const slots = { anterior: 'Anterior', exato: 'Exato', posterior: 'Posterior' }
        const minResult = this.minResultOf(signal)
        return (
            <div>
                {this.renderTypeResultsTable(signal)}
                {!rows.length ? (
                    <div style={{ color: '#888' }}>Nenhum resultado a partir do minuto do sinal (até 4 posições).</div>
                ) : (
                    <div>
                        <strong>Resultados a partir de {formatLocalDateTime(signal.date)} (posições 1–4, sucesso &gt;= {minResult}x)</strong>
                        <table className='table table-condensed table-bordered' style={{ marginTop: 8, marginBottom: 0, background: '#fff' }}>
                            <thead>
                                <tr>
                                    <th>Minuto</th>
                                    <th>Horário</th>
                                    <th>Crash</th>
                                    <th>Jogadores</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((row) => {
                                    const inPlay = Number(row.position) >= 1
                                    const win = inPlay && Number(row.value) >= minResult
                                    return (
                                        <tr key={row.id} style={{ background: inPlay ? (win ? '#e8f5e9' : '#fff8e1') : undefined, fontWeight: inPlay ? 600 : 400 }}>
                                            <td>{row.position ? `${row.position}ª · ${slots[row.slot] || row.slot}` : (slots[row.slot] || row.slot)}</td>
                                            <td>{formatUtcAsLocal(row.created_at)}</td>
                                            <td style={{ color: Number(row.value) >= minResult ? '#2e7d32' : (Number(row.value) <= 1.001 ? '#c62828' : undefined) }}>
                                                {Number(row.value).toFixed(2)}x
                                            </td>
                                            <td>{row.players}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        )
    }

    render() {
        const writeCodes = [2, 3, 6, 7, 10, 11, 14, 15]
        const signalActions = (this.props.scopes && this.props.scopes.crash_signals && this.props.scopes.crash_signals.actions) || {}
        const canWriteSignals = !this.props.readOnly
            && Object.values(signalActions).some((code) => writeCodes.indexOf(Number(code)) > -1)

        return (
            <>
                <If test={this.props.show === 'form' && canWriteSignals}>
                    <Content>
                        <form onSubmit={this.props.handleSubmit(this.onSubmit)}>
                            
                            <Row>
                                <Field name='date' type='datetime-local' component={LabelAndInput} readOnly={this.props.readOnly}
                                        label='Horário exato' cols='12 2' placeholder='00/00/0000 00:00' error={this.props.errors} val={toLocalInputValue()} />
                                <Field style={{display:'none'}} name='percent_to_start' type='number' step='any' component={LabelAndInput} readOnly={this.props.readOnly}
                                        label='% de entrada (legado — use o cadastro do bot)' cols='12 2' placeholder='0.00' error={this.props.errors} val={this.state.percent_to_start} onChange={e => this.setState({percent_to_start: e.target.value})}
                                        title='Movido para o cadastro do usuário Bot.'/>
                                <Field style={{display:'none'}} name='martingale_steps' type='number' step='1' component={LabelAndInput} readOnly={this.props.readOnly}
                                        label='Gale (legado — use o cadastro do bot)' cols='12 2' placeholder='00' error={this.props.errors} val={this.state.martingale_steps} onChange={e => this.setState({martingale_steps: e.target.value})} />
                                <Field name='min_result' type='number' step='any' min='1.01' component={LabelAndInput} readOnly={this.props.readOnly}
                                        label='Resultado mínimo (>=)' cols='12 2' placeholder='2.00' error={this.props.errors}
                                        title='Crash mínimo que conta como sucesso. Em branco, herda do prompt do sinal.'/>
                                <Field style={{display:'none'}} name='percent_after_lose' type='number' step='any' component={LabelAndInput} readOnly={this.props.readOnly}
                                        label='% de aumento a cada perda' cols='12 2' placeholder='0.00' error={this.props.errors} val={100}
                                        title='Caso a primeira aposta seja uma perda, o bot irá iniciar o martingale, e em cada nova aposta, essa será a porcentagem do saldo que será somada à nova aposta.'/>
                                <Field style={{display:'none'}} name='percent_to_recovery' type='number' step='any' component={LabelAndInput} readOnly={this.props.readOnly}
                                        label='% de entradas de recuperação' cols='12 2' placeholder='0.00' error={this.props.errors} val={2}/>
                                <Field style={{display:'none'}} name='percent_lost_to_stop' type='number' step='any' component={LabelAndInput} readOnly={this.props.readOnly}
                                        label='% máxima de perda' cols='12 2' placeholder='0.00' error={this.props.errors} val={10} />
                                <Field style={{display:'none'}} name='value_lost_to_stop' type='number' step='any' component={LabelAndInput} readOnly={this.props.readOnly}
                                        label='R$ máximo de perda' cols='12 2' placeholder='0.00' error={this.props.errors}val={120} />
                                <Field style={{display:'none'}} name='percent_win_to_stop' type='number' step='any' component={LabelAndInput} readOnly={this.props.readOnly}
                                        label='% máxima de lucro' cols='12 2' placeholder='0.00' error={this.props.errors} val={30}/>
                                <Field style={{display:'none'}} name='value_win_to_stop' type='number' step='any' component={LabelAndInput} readOnly={this.props.readOnly}
                                        label='R$ máximo de lucro' cols='12 2' placeholder='0.00' error={this.props.errors} val={100} />
                                <Field style={{display:'none'}} name='wait_positive_signals' type='number' placeholder='00' component={LabelAndInput} readOnly={this.props.readOnly}
                                        label='Esperar sinais positivos (legado — use o cadastro do bot)' cols='12 2' error={this.props.errors} val={3}/>
                                
                            </Row>
                            <Row>
                                <button type='submit' className={`btn btn-primary`}>Salvar</button>
                                <button type='button' className='btn btn-default' onClick={this.props.init}>Cancelar</button>
                            </Row>
                        </form>
                    </Content>
                </If>
                <If test={this.props.show === 'list' && canWriteSignals}>
                    <button className="btn btn-primary" onClick={() => this.props.showCreate()}>Adicionar</button>
                    <br /><br />
                </If>
                <Table body={[...this.props.list]} labelMobile="date"
                    renderSubRow={this.renderAroundResults}
                    attributes={{
                        date: {
                            title: 'Horário',
                            callback: (val) => formatLocalDateTime(val),
                        },
                        martingale_steps: {
                            title: 'Posição',
                            callback: (val, signal) => {
                                const x = signal.predicted_position != null && signal.predicted_position !== ''
                                    ? Number(signal.predicted_position)
                                    : null
                                const y = signal.actual_position != null && signal.actual_position !== ''
                                    ? Number(signal.actual_position)
                                    : null
                                const xLabel = Number.isFinite(x) && x > 0 ? x : '—'
                                const yLabel = Number.isFinite(y) && y > 0 ? y : '—'
                                return `${xLabel}/${yLabel}`
                            }
                        },
                        crash_prompt: {
                            title: 'Prompt',
                            callback: (val, signal) => {
                                if (val && val.title) return val.title
                                if (signal.crash_prompt && signal.crash_prompt.title) {
                                    return signal.crash_prompt.title
                                }
                                if (signal.crash_prompt_id) return `#${signal.crash_prompt_id}`
                                return '—'
                            }
                        },
                        min_result: {
                            title: 'Mínimo',
                            callback: (val, signal) => `>= ${this.minResultOf(signal)}x`,
                        },
                        bot_activity: {
                            title: 'Bot',
                            style: { whiteSpace: 'nowrap' },
                            callback: (val, signal) => this.renderBotActivity(val, signal),
                        },
                        outcome: {
                            title: 'Resultado',
                            style: { minWidth: 168 },
                            callback: (val, signal) => this.renderOutcome(signal),
                        },
                    }} />
                
            </>
        );
    }
}

FormCrashSignal = reduxForm({ form: 'crashSignalForm', destroyOnUnmount: false })(FormCrashSignal)
const selector = formValueSelector('crashSignalForm')
const mapStateToProps = state => ({
    date: selector(state, 'date'),
    percent_to_start: selector(state, 'percent_to_start'),
    percent_after_lose: selector(state, 'percent_after_lose'),
    percent_to_recovery: selector(state, 'percent_to_recovery'),
    percent_lost_to_stop: selector(state, 'percent_lost_to_stop'),
    value_lost_to_stop: selector(state, 'value_lost_to_stop'),
    percent_win_to_stop: selector(state, 'percent_win_to_stop'),
    value_win_to_stop: selector(state, 'value_win_to_stop'),
    wait_positive_signals: selector(state, 'wait_positive_signals'),
    martingale_steps: selector(state, 'martingale_steps'),
    min_result: selector(state, 'min_result'),
    userId: state.auth.user.id,
    errors: state.crashSignal.errors,
    list: state.crashSignal.list,
    show: state.crashSignal.show,
    scopes: (state.auth.profile && state.auth.profile.scopes) || {},
})
const mapDispatchToProps = dispatch => bindActionCreators({ 
    init, create, update, getList, refreshList, showContent, showCreate }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(FormCrashSignal)